export class useRem {
    private baseSize = 16

    constructor() {
        this.setRem()
        window.addEventListener('resize', this.setRem.bind(this), false)
    }

    private setRem() {
        const scale = document.documentElement.clientWidth / 1920
        document.documentElement.style.fontSize = this.baseSize * Math.min(scale, 2) + 'px'
    }
}